export default __webpack_public_path__ + "static/media/trash.667f51f1.svg";